module.exports = __webpack_public_path__ + "img/3682052.jpg";